module.exports = __webpack_public_path__ + "img/exclamation.1f0e149b.svg";